import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import { getLocalStorageAccessToken, getUrlParam, USERS_SET_LANGUAGE } from "utils";

const lang = process.env.REACT_APP_LANG || "en";

i18n.use(Backend)
    .use(detector)
    .use(initReactI18next)
    .init(
        {
            detection: {
                order: ["localStorage", "querystring"],
                lookupSessionStorage: USERS_SET_LANGUAGE,
                lookupQuerystring: "language",
            },
            fallbackLng: "en",
            preload: [lang],
            ns: ["translations"],
            defaultNS: "translations",
            backend: {
                loadPath: `${process.env.REACT_APP_SERVER_API_ADDRESS}/{{ns}}?language={{lng}}`,
                customHeaders: {
                    authorization: `Bearer ${getUrlParam("jwt") || getLocalStorageAccessToken()}`,
                },
            },
        },
        (err: Error) => {
            if (err) {
                return console.error(err);
            }
        }
    );

export default i18n;
